import React, { useState, useEffect, useCallback, useRef } from 'react'
import {
  Table,
  Empty,
  Card,
  Spin,
  Button,
  Notification,
  Modal,
  Form,
  Input
} from '@arco-design/web-react'

import Emptydata_img from 'asserts/Emptydata_img.svg'
import {
  getSubUserList,
  getAllClass,
  addSubUser,
  updateSubUserStatus
} from 'api/apis'
import { IconSync, IconStop } from '@arco-design/web-react/icon'
import './index.scss'

import { useLocation } from 'react-router-dom'

const SubUser = () => {
  const location = useLocation()

  // 拆分分页状态：用户操作的部分（current、pageSize）和接口返回的部分（total）
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    limit: 10
  })
  const [totalCount, setTotalCount] = useState(0) // 单独存储总数，避免影响依赖

  // 其他状态
  const [loadingbody, setLoadingbody] = useState(true)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [noData, setNoData] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [type, setType] = useState('')
  const [classType, setClassType] = useState('全部')
  const [apply, setApply] = useState('全部')
  const [modalVisible, setModalVisible] = useState(false)
  const [uid, setUid] = useState('')
  const [nickname, setNickname] = useState('')
  const [mobile, setMobile] = useState('')

  const formRef = useRef()
  // 表格列定义
  const columns = [
    {
      title: 'union_id ',
      dataIndex: 'union_id',
      align: 'center',
      headerCellStyle: {
        textAlign: 'center',
        height: 68
      }
    },
    {
      title: '用户昵称',
      dataIndex: 'nickname',
      align: 'center',
      headerCellStyle: {
        textAlign: 'center'
      }
    },
    {
      title: '用户手机号 ',
      dataIndex: 'mobile',
      align: 'center',
      headerCellStyle: {
        textAlign: 'center'
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      headerCellStyle: {
        textAlign: 'center'
      },
      render: (text, record) => {
        if (text === 'BAN') {
          return <div className="stateRedBox">禁用</div>
        } else if (text === 'NORMAL') {
          return <div className="stateGreenBox">正常</div>
        }
        return <span>{text}</span>
      }
    },
    {
      title: '操作',
      dataIndex: 'status',
      align: 'center',
      headerCellStyle: {
        textAlign: 'center'
      },
      render: (text, record) => {
        if (text === 'NORMAL') {
          return (
            <div
              className="whiteBox"
              style={{ cursor: 'pointer' }}
              onClick={() => changeUserStatus(record)}
            >
              <IconStop style={{ zIndex: 1, color: 'white', fontSize: 18 }} />
            </div>
          )
        } else if (text === 'BAN') {
          return (
            <div
              className="grayBox"
              style={{ cursor: 'pointer' }}
              onClick={() => changeUserStatus(record)}
            >
              <IconStop style={{ zIndex: 1, color: '#374151', fontSize: 18 }} />
            </div>
          )
        }
        return <span>{text}</span>
      }
    }
  ]

  // 获取数据（依赖用户操作的状态，不依赖total）
  const getBalance = useCallback(() => {
    const pageParams = {
      ...pageInfo,
      app_id: localStorage.getItem('app_id'),
      key: keyword || ''
    }
    setLoading(true)
    getSubUserList(pageParams)
      .then((res) => {
        if (res.code === 200) {
          const list = res.data
          setTotalCount(list.total) // 只更新总数，不影响pageInfo
          setData(list.data || [])
          setNoData(list.total > 0 ? false : true)
        } else {
          setTotalCount(0)
          setData([])
          setNoData(true)
        }
      })
      .catch((err) => {
        console.error('获取数据失败:', err)
        setData([])
        setNoData(true)
      })
      .finally(() => {
        setLoading(false)
        setLoadingbody(false)
      })
  }, [pageInfo, keyword, type, classType, apply]) // 依赖用户可操作的状态

  // 获取分类列表
  const getAllClassData = useCallback(() => {
    const newMenu = [{ key: '99', label: '全部', value: '全部' }]
    getAllClass()
      .then((res) => {
        if (res.code === 200) {
          const list = res.data
          list.forEach((item, index) => {
            newMenu.push({ key: index.toString(), label: item, value: item })
          })
          // setMenuItems(newMenu)
        } else {
          // setMenuItems(newMenu)
          Notification.error({ content: res.msg })
        }
      })
      .catch((err) => {
        console.error('获取分类失败:', err)
        // setMenuItems(newMenu)
      })
  }, [])

  // 处理URL参数
  const handleMyParam = useCallback(
    (myParam) => {
      getBalance()
    },
    [getBalance]
  )

  // 表格分页变化（只更新用户操作的current和pageSize）
  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination
    setPageInfo({ current, pageSize })
  }

  // 关键词搜索
  const handleSearch = (value) => {
    console.log('value:', value)
    setKeyword(value)
    setPageInfo((prev) => ({ ...prev, page: 1 })) // 重置页码
  }

  // 打开添加用户弹窗
  const handleAddUser = () => {
    setModalVisible(true)
  }

  // 刷新数据
  // const handleRefresh = () => {
  //   getBalance()
  // }
  const changeUserStatus = (record) => {
    if (record.status === 'BAN') {
      Notification.error({ content: '已禁用户，无法启用' })
      return
    }
    const params = {
      app_id: localStorage.getItem('app_id'),
      union_id: record.union_id,
      status: record.status === 'NORMAL' ? 'BAN' : 'NORMAL'
    }
    updateSubUserStatus(params)
      .then((res) => {
        if (res.code === 200) {
          Notification.success({ content: '修改子用户状态成功' })
          getBalance()
        } else {
          Notification.error({ content: res.msg })
        }
      })
      .catch((err) => {
        console.error('修改子用户状态失败:', err)
        Notification.error({ content: '修改子用户状态失败' })
      })
  }
  // 初始化：只在组件挂载/URL参数变化时执行
  useEffect(() => {
    getAllClassData()
    const queryParams = new URLSearchParams(location.search)
    const myParam = queryParams.get('id')
    handleMyParam(myParam)
  }, [getAllClassData, handleMyParam, location.search])

  // 仅在用户操作导致状态变化时请求数据（无循环依赖）
  useEffect(() => {
    if (!loadingbody) {
      // 避免与初始化请求重复
      getBalance()
    }
  }, [pageInfo, keyword, type, classType, apply]) // 只依赖用户可直接修改的状态

  // 组合分页参数给Table组件
  const pagination = {
    sizeCanChange: false,
    showTotal: true,
    total: totalCount, // 使用单独的totalCount
    current: pageInfo.current,
    pageSize: pageInfo.pageSize,
    pageSizeChangeResetCurrent: true,
    showJumper: false
  }

  const handleAddUserSubmit = () => {
    if (!uid || !nickname || !mobile) {
      Notification.error({ content: '请填写完整信息' })
      return
    }
    const params = {
      uid: uid,
      nickname: nickname,
      mobile: mobile,
      app_id: localStorage.getItem('app_id')
    }

    addSubUser(params)
      .then((res) => {
        if (res.code === 200) {
          Notification.success({ content: '添加子用户成功' })
          setUid('')
          setNickname('')
          setMobile('')
          setModalVisible(false)
          getBalance()
        } else {
          Notification.error({ content: res.msg })
        }
      })
      .catch((err) => {
        console.error('添加子用户失败:', err)
        Notification.error({ content: '添加子用户失败' })
      })
  }

  useEffect(() => {
    console.log('keyword:', keyword)
  }, [keyword])

  return (
    <div className="payment-details">
      <div className="Header-init">
        <div className="Header-title">子用户管理</div>
      </div>

      <div className="over-header">
        <div className="over-header-left">
          <div className="over-icon"></div>
          <div className="over-line"></div>
          <Input
            className="search-input"
            placeholder="请输入用户昵称"
            value={keyword}
            onChange={(value) => handleSearch(value)}
            onPressEnter={() => handleSearch(keyword)}
          />
        </div>

        <div>
          <Button
            type="primary"
            className="custom-Blue-button"
            onClick={handleAddUser}
          >
            + 添加用户
          </Button>
          {/* <Button
            className="custom-White-button"
            onClick={handleRefresh}
            icon={<IconSync />}
          >
            刷新
          </Button> */}
        </div>
      </div>

      {loadingbody ? (
        <Spin loading={loadingbody} dot className="loadingbody"></Spin>
      ) : (
        <Card
          bordered={false}
          hoverable
          style={{ borderRadius: 20 }}
          className="Table-card"
        >
          <Table
            style={{ marginTop: 30 }}
            virtualized
            noDataElement={
              <Empty imgSrc={Emptydata_img} description={'暂无子用户记录'} />
            }
            no_data={noData}
            border={{ wrapper: false, cell: false }}
            loading={loading}
            columns={columns}
            data={data}
            pagination={totalCount === 0 ? false : pagination}
            onChange={handleTableChange}
            renderPagination={(paginationNode) => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 30
                }}
              >
                {paginationNode}
              </div>
            )}
            rowKey="id"
          />
          <Modal
            title={<div style={{ textAlign: 'left' }}>添加用户</div>}
            visible={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px'
                }}
              >
                <Button onClick={() => setModalVisible(false)}>取消</Button>
                <Button type="primary" onClick={handleAddUserSubmit}>
                  确定
                </Button>
              </div>
            }
          >
            <Form ref={formRef} layout="vertical" autoComplete="off">
              <Form.Item
                name="uid"
                label="uid(用户唯一标识)"
                rules={[
                  { required: true, message: '请输入用户唯一标识' },
                  { pattern: /^\S+$/, message: '不可包含空格' }
                ]}
              >
                <Input
                  className="custom-input"
                  value={uid}
                  onChange={(value) => setUid(value)}
                />
              </Form.Item>
              <Form.Item
                name="nickname"
                label="nickname(用户昵称)"
                rules={[
                  { required: true, message: '请输入用户昵称' },
                  { max: 20, message: '昵称长度不超过20个字符' }
                ]}
              >
                <Input
                  className="custom-input"
                  value={nickname}
                  onChange={(value) => setNickname(value)}
                />
              </Form.Item>
              <Form.Item
                name="mobile"
                label="mobile(手机号码)"
                rules={[
                  { required: true, message: '请输入手机号码' },
                  {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入正确的11位手机号'
                  }
                ]}
              >
                <Input
                  className="custom-input"
                  value={mobile}
                  onChange={(value) => setMobile(value)}
                />
              </Form.Item>
            </Form>
          </Modal>
        </Card>
      )}
    </div>
  )
}

export default SubUser
